__turbopack_context__.v({
  "grid": "styles-module-scss-module__5j9euW__grid",
  "img": "styles-module-scss-module__5j9euW__img",
  "item": "styles-module-scss-module__5j9euW__item",
  "list": "styles-module-scss-module__5j9euW__list",
  "root": "styles-module-scss-module__5j9euW__root",
  "section": "styles-module-scss-module__5j9euW__section",
  "section_hidden": "styles-module-scss-module__5j9euW__section_hidden",
  "subtitle": "styles-module-scss-module__5j9euW__subtitle",
  "subtitle_hidden": "styles-module-scss-module__5j9euW__subtitle_hidden",
  "title": "styles-module-scss-module__5j9euW__title",
  "wrapper": "styles-module-scss-module__5j9euW__wrapper",
});
